import React, { useEffect, useRef } from 'react';
import { Modal, Button, Form, ModalBody, ModalHeader, ModalFooter, FormGroup, Label, Row, Col, Input, Container, FormFeedback, } from 'reactstrap';
import { ListOrderingItem } from '../../components/lists/ListOrderingItem';
import { Dialog } from 'primereact/dialog';


export const ModalOrderAnalytes = (props) => {
    const {
        analytesGroup, handleModalOrder: toggle, modalOrder, loadingOrder, saveOrderAnalytes
    } = props;

    const contentRef = useRef(null);

    useEffect(() => {
    if (!modalOrder) return;

    setTimeout(() => {
        const content = contentRef.current;
        const mask = document.querySelector('.p-dialog-mask');

        if (!content || !mask) return;

        const hasScroll = content.scrollHeight > content.clientHeight;

        mask.classList.remove('centered', 'top-aligned');
        mask.classList.add(hasScroll ? 'top-aligned' : 'centered');
    }, 50);
    }, [modalOrder, analytesGroup]);


    return (
        <Dialog
            header="Ordenar analitos"
            visible={modalOrder}
            onHide={toggle}
            closable
            modal
            blockScroll
            className="adaptive-dialog"
            >
            <div ref={contentRef}>
                <label className="text-gray text-sm">
                Arrastre y suelte los grupos y analitos para ordenarlos
                </label>

                <ListOrderingItem itemsOrdered={analytesGroup} {...{ modalOrder }} />

                <ModalFooter>
                <Button
                    onClick={() => saveOrderAnalytes(analytesGroup)}
                    color="primary"
                    type="submit"
                    className={loadingOrder ? "disabled progress-bar-animated progress-bar-striped" : ""}
                >
                    Ordenar analitos
                </Button>
                <Button color="danger" type="button" onClick={toggle}>
                    Cancelar
                </Button>
                </ModalFooter>
            </div>
        </Dialog>

    )
}
